import React from "react";

import styled from "styled-components";

const GlassContainer = styled.div`
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20x);
  filter: brightness(1.3);
  border-radius: 0px;
  padding: ${(props) => props.padding ?? "20px"};
  height: ${(props) => (props.designId === 3 ? "80vh" : "86vh")};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  overflow-y: visible;

  @media screen and (max-width: 900px) {
    width: 100vw;
    height: 76vh;
    justify-content: flex-start;
    padding: 10%;
  }
  @media screen and (max-width: 676px) {
    padding: 5%;
  }
`;

const GlassContainerComponent = ({ children, padding, designId }) => {
  return (
    <GlassContainer designId={designId} padding={padding}>
      {children}
    </GlassContainer>
  );
};

export default GlassContainerComponent;
